import { render, staticRenderFns } from "./MyGroupsTabs.vue?vue&type=template&id=40db7b08&scoped=true"
import script from "./MyGroupsTabs.vue?vue&type=script&lang=js"
export * from "./MyGroupsTabs.vue?vue&type=script&lang=js"
import style0 from "./MyGroupsTabs.vue?vue&type=style&index=0&id=40db7b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db7b08",
  null
  
)

export default component.exports